import React, { useState } from "react";
import SearchIcon from "../../icons/searchHeader.svg";
import AccountIcon from "../../icons/account.svg";
import LanguageSwitcher from "../LanguageSwitcher";
import BurgerButton from "../BurgerButton";
import MobileBar from "../Mobilebar";
import { DropDirection } from "../../types/constants";
import { Link } from "react-router-dom";

export default function HeaderIcons() {
    const [isOpen, setIsOpen] = useState(false);

    const openMenu = () => setIsOpen(true);
    const closeMenu = () => setIsOpen(false);

    return (
        <>
            <div className="flex items-center gap-7 xl:gap-8">
                <div className="hidden xl:flex">
                    <LanguageSwitcher dropDirection={DropDirection.DOWN} dropdownRightOffset="-right-[50px]" />
                </div>
                {/* <button type="button" aria-label="Пошук" className="w-7 h-7 md:w-8 md:h-8">
                    <img src={SearchIcon} alt="" />
                </button>*/
                <Link to="/account">
                <button type="button" aria-label="Акаунт" className="w-7 h-7 md:w-8 md:h-8">
                    <img src={AccountIcon} alt="" />
                </button> </Link>}
                <div className="xl:hidden">
                    <BurgerButton onClick={openMenu} />
                </div>
            </div>
            <MobileBar isOpen={isOpen} onClose={closeMenu} />
        </>
    );
}
